import { render } from "./PantryCameraDateDialog.vue?vue&type=template&id=f64ee8fc&ts=true"
import script from "./PantryCameraDateDialog.vue?vue&type=script&lang=ts"
export * from "./PantryCameraDateDialog.vue?vue&type=script&lang=ts"

import "./PantryCameraDateDialog.vue?vue&type=style&index=0&id=f64ee8fc&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__